module.exports = __webpack_public_path__ + "img/todoCategories.ca6e9cc6.webp";